export * from "./gtg-stock-request.component";
